import { Stack, Text, UnstyledButton } from '@mantine/core';
import { FaqChildNode } from '@mygpt/types';
import { FetchQuestionOptions } from '@mygpt/app/chat/hooks';

interface Props {
  aiId: string;
  list: FaqChildNode[];
  onClick: (value: string, options?: FetchQuestionOptions) => void;
  botMessageTextColor?: string;
  isDigitalHuman?: boolean;
}

const FaqChildNodeList: React.FC<Props> = ({ aiId, list, onClick, botMessageTextColor, isDigitalHuman }) => {
  return (
    <Stack align="flex-start">
      {list.map((item, index) => (
        <UnstyledButton
          key={index}
          className={`max-w-full rounded-lg py-2 px-3 transition-all duration-200 ${
            isDigitalHuman
              ? 'bg-white/90 backdrop-blur-md shadow-lg hover:bg-white hover:shadow-xl border-none'
              : 'bg-white border border-gray-200 hover:border-gray-400 shadow-sm hover:shadow-md'
          }`}
          onClick={() => onClick(item.name, { faqID: item.id })}
        >
          <Text
            size="xs"
            c={isDigitalHuman ? 'dark' : botMessageTextColor ? undefined : 'violet.7'}
            fw={500}
            style={!isDigitalHuman && botMessageTextColor ? { color: botMessageTextColor } : undefined}
          >
            {item.name}
          </Text>
        </UnstyledButton>
      ))}
    </Stack>
  );
};

export default FaqChildNodeList;
